export default {
  GET_USER_INFO (state, data) {
    state.me = Object.assign({}, state.me, data)
  },
  GET_MENU_STATUS (state, data) {
    state.menu_status = data
    sessionStorage.setItem('initState', JSON.stringify(state))
  },
  GET_CURRENT_CITY (state, data) {
    state.currentCity = data
    sessionStorage.setItem('initState', JSON.stringify(state))
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js